export const UPDATE_CASE_LIST_FILTERS = 'UPDATE_CASE_LIST_FILTERS';
export const FETCH_CASES = 'FETCH_CASES';
export const FETCH_CASES_SUCCESS = 'FETCH_CASES_SUCCESS';
export const FETCH_CASES_FAIL = 'FETCH_CASES_FAIL';
export const CHANGE_CASE_LIST_PAGE = 'CHANGE_CASE_LIST_PAGE';
export const CHANGE_CASE_LIST_PAGE_SIZE = 'CHANGE_CASE_LIST_PAGE_SIZE';
export const RELOAD_CASES = 'RELOAD_CASES';
export const SELECT_CASES = 'SELECT_CASES';
export const SELECT_CASES_ID = 'SELECT_CASES_ID';
export const ASSIGN_CASE_TO_USER = 'ASSIGN_CASE_TO_USER';
export const ASSIGN_CASE_TO_USER_SUCCESS = 'ASSIGN_CASE_TO_USER_SUCCESS';
export const ASSIGN_CASE_TO_USER_FAIL = 'ASSIGN_CASE_TO_USER_FAIL';
export const ASSIGN_CASE_ACTION_INFO_MODAL_CLOSE =
  'ASSIGN_CASE_ACTION_INFO_MODAL_CLOSE';
export const ASSIGN_CASE_TO_USER_RESET = 'ASSIGN_CASE_TO_USER_RESET';

export const updateCaseListFilters = (filters) => ({
  type: UPDATE_CASE_LIST_FILTERS,
  payload: filters
});

export const fetchCases = ({ filters, currentPage, pageSize }) => ({
  type: FETCH_CASES,
  payload: { filters, currentPage, pageSize }
});

export const fetchCasesSuccess = ({ cases, total }) => ({
  type: FETCH_CASES_SUCCESS,
  payload: { cases, total }
});

export const fetchCasesFail = (message) => ({
  type: FETCH_CASES_FAIL,
  payload: { message }
});

export const changeCaseListPage = (currentPage) => ({
  type: CHANGE_CASE_LIST_PAGE,
  payload: currentPage
});

export const changeCaseListPageSize = (pageSize) => ({
  type: CHANGE_CASE_LIST_PAGE_SIZE,
  payload: pageSize
});

export const reloadCases = ({ keepSelection } = {}) => ({
  type: RELOAD_CASES,
  payload: { keepSelection }
});

export const selectCaseIds = (selectedIds) => ({
  type: SELECT_CASES_ID,
  payload: selectedIds
});

export const selectCases = (selectCases) => ({
  type: SELECT_CASES,
  payload: selectCases
});

export const assignCaseToUser = ({ caseIds, user }) => ({
  type: ASSIGN_CASE_TO_USER,
  payload: { caseIds, user }
});

export const assignCaseToUserSuccess = () => ({
  type: ASSIGN_CASE_TO_USER_SUCCESS
});

export const assignCaseToUserFail = (message) => ({
  type: ASSIGN_CASE_TO_USER_FAIL,
  payload: { message }
});

export const assignCaseActionInfoModalClose = (selectedIds) => ({
  type: ASSIGN_CASE_ACTION_INFO_MODAL_CLOSE,
  payload: selectedIds
});

export const assignCaseToUserReset = () => ({
  type: ASSIGN_CASE_TO_USER_RESET
});
